import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12,
    padding: '5px 12px',
    borderRadius: 20,
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  incomplete: {
    background: '#FEF3E2',
    color: '#B45309',
  },
  complete: {
    background: '#ECFDF5',
    color: '#047857',
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    flexShrink: 0,
  },
  dotIncomplete: { background: '#F59E0B' },
  dotComplete: { background: '#10B981' },
}));

const SetupStatusBadge = ({ complete }) => {
  const classes = useStyles();
  return (
    <span className={`${classes.badge} ${complete ? classes.complete : classes.incomplete}`}>
      <span className={`${classes.dot} ${complete ? classes.dotComplete : classes.dotIncomplete}`} />
      {complete ? 'Setup complete' : 'Setup in progress'}
    </span>
  );
};

export default SetupStatusBadge;
